import React from 'react';

import { Label } from 'core/components/label';
import { Button } from 'core/components/button';

import useStyles from '../footer.styles';

const BranchPlusOnlyFooter = () => {
  const classes = useStyles();

  return (
    <div className={classes.footerRow}>
      <div className={classes.titleContainer}>
        <Label className={classes.invalidOptionTitle} type="subtitle">
          We can only sell Branch Plus policies at this location.
        </Label>
        <Label className={classes.invalidOptionSubtitle} type="whiteSmall">
          When this offer was generated, we did not offer BIX policies at this state or location. If you believe this is
          wrong, please create a new offer.
        </Label>
      </div>
      <Button
        className={classes.scrollButton}
        variant="contained"
        color="primary"
        type="submit"
        onClick={() => {
          const element = document.getElementById('QuinstreetOffers');
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }}
      >
        <Label>Go to Branch Plus offers</Label>
      </Button>
    </div>
  );
};
export default BranchPlusOnlyFooter;
